import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import { toast } from 'sonner';
import { XCircle, AlertTriangle } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const MeetingCancel = () => {
  const { meetingId } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleCancel = async () => {
    setLoading(true);
    try {
      await axios.post(`${API}/meetings/action`, {
        meetingId,
        action: 'cancel'
      });

      toast.success('Meeting cancelled successfully');
      navigate('/');
    } catch (error) {
      toast.error('Failed to cancel meeting');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-slate-100 flex items-center justify-center py-8 px-4">
      <Card className="max-w-md w-full p-8 bg-white shadow-xl">
        <div className="text-center">
          <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <AlertTriangle className="w-12 h-12 text-red-600" />
          </div>
          
          <h1 className="text-2xl font-bold text-slate-900 mb-3" style={{fontFamily: 'Space Grotesk, sans-serif'}}>
            Cancel Meeting?
          </h1>
          <p className="text-slate-600 mb-8">
            Are you sure you want to cancel this meeting? This action cannot be undone.
          </p>

          <div className="flex gap-3">
            <Button
              variant="outline"
              onClick={() => navigate('/')}
              className="flex-1"
            >
              Go Back
            </Button>
            <Button
              onClick={handleCancel}
              disabled={loading}
              className="flex-1 bg-red-600 hover:bg-red-700 text-white"
            >
              <XCircle className="w-4 h-4 mr-2" />
              {loading ? 'Cancelling...' : 'Yes, Cancel Meeting'}
            </Button>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default MeetingCancel;
